const Backbone = require('backbone');
const FacetItemView = require('app/views/store/pages/categories/facet_item');
const FacetDictionaryModel = require('app/models/store/client/category_dictionary');
const { RangeFacetView } = require('common/range_facet');
const window = require('window');
const dustjs = require('dustjs');
const _facetGroupDust = require('store/global/pages/categories/_facet_group.dust');

module.exports = Backbone.View.extend({
	_template: _facetGroupDust,
	tagName: 'li',

	className: function() {
		const active = !this.model.get('isCollapsed') ? ' active' : '';
		const desktopClasses = !window.BCOM.device.isDesktop ? 'ba bw2 b--theme-grey' : ' ';
		return window.BCOM.theme.isLivingDirect
			? `item bg-theme-white list ma0 pointer ${desktopClasses} js-group js-group-${this.model.get('id')}${active}`
			: `item bg-theme-white list mh0 mt2 pointer js-group js-group-${this.model.get('id')}${active}`;
	},

	events: {
		'click .js-track-help-icon': '_triggerHelpIconTracking',
		'click .js-help-icon': '_fetchDictionaryTerm',
		'mouseover .js-help-icon': '_fetchDictionaryTerm',
		'input .js-facet-filter': '_filterFacetGroup',
		'click .js-facet-expand': '_getMoreFacetItems'
	},

	initialize(options = {}) {
		this.options = options;

		// note: facet_list passes these in if LDI
		this.tagName = this.options.tagName || this.tagName;
		this._template = this.options.template || this._template;

		this._allFacets = this.$el.find('.js-group-list li').filter(this._getFacetListItems);

		// for accordion_list.js and selenium
		this.$el.attr('data-groupname', this.model.get('groupName'));

		// trigger from facet_list.js. Need to remove children FacetItemViews as well.
		this.listenTo(this, 'removeyourself', this._removeViewAndChildViews.bind(this));

		// when facets.js collection gets 'set' with new models after a fetch, it will destroy any removed models.
		this.listenTo(this.model, 'destroy', this._onDestroy.bind(this));

		this.listenTo(this.model, 'external:collapse', this._collapseFacetGroup.bind(this));

		if (!this.model.attributes.isCollapsed) {
			this._getMoreFacetItems();
		}

		this._initDictionaryTerm();
	},

	render() {
		// adding Features Overrides to template for AB Test for Dictionary Removal
		const data = Object.assign({}, this.model.toJSON(), {
			device: window.BCOM.device
		});
		dustjs.render(this._template, data, (error, markup) => {
			this.$el.html(markup);
			if (this.model.get('isRanged')) {
				this._renderFacetSliderGroup();
			} else {
				this._renderFacetGroupItems();
			}

			this._allFacets = this.$el.find('.js-group-list li').filter(function() {
				return !$(this).hasClass('.js-facet-filter-container');
			});
		});

		let selectedValues = this.model.get('selectedValues');
		if (typeof selectedValues === 'string' && selectedValues.toLowerCase() === '1-2day') {
			selectedValues = '';
		}
		this.$('.js-selected-facets')
			.text(selectedValues)
			.removeClass('dn');

		return this;
	},

	_getFacetListItems() {
		return !$(this).hasClass('js-facet-filter-container');
	},

	_renderFacetGroupItems() {
		const $group = this.$('.js-group-list');

		$group
			.find('li')
			.filter(this._getFacetListItems)
			.remove();

		this._removeFacetItemViews();

		this.facetItemViews = [];
		this.model.get('facetItemCollection').each((model) => {
			const facetItemView = new FacetItemView({ model });
			$group.append(facetItemView.render().el);
			this.facetItemViews.push(facetItemView);
		});
	},

	_collapseFacetGroup() {
		this.model.set('isCollapsed', true);
		this.$el.removeClass('active');
	},

	_onDestroy() {
		this._removeViewAndChildViews();
	},

	_removeViewAndChildViews() {
		this._removeFacetItemViews();
		this.remove();
	},

	_removeFacetItemViews() {
		if (this.facetItemViews && this.facetItemViews.length) {
			this.facetItemViews.forEach((view) => {
				this.stopListening(view.model);
				view.model.destroy();
			});
		}
	},
	/** @function _getMoreFacetItems: this function is used for getting more refinements from GBI. */
	_getMoreFacetItems() {
		if (this.model.attributes.autoFetch && this.model.attributes.moreRefinements) {
			let facetId = this.model.attributes.resultValues[0].facetId;
			this.model.fetch({
				url: `refinements/${window.location.search}&facetId=${facetId}`,
				success: () => {
					this.model.trigger('facets:collection:complete');
					this.render();
				}
			});
		}
	},
	/**
	 * ==================================================================================
	 * ********** SPECIAL SNOWFLAKE FACET GROUP... RANGE SLIDER *************************
	 * ==================================================================================
	 */

	_renderFacetSliderGroup() {
		const facetGroup = this.model.toJSON(),
			min = facetGroup.formatted.min,
			max = facetGroup.formatted.max,
			selectedMin = typeof facetGroup.selectedMin === 'number' ? facetGroup.selectedMin : min,
			selectedMax = typeof facetGroup.selectedMax === 'number' ? facetGroup.selectedMax : max,
			useApplyButton = Boolean(window.BCOM.device.isDesktop || window.BCOM.theme.isLivingDirect);

		if (this.rangeSlider) {
			return this._updateRangeSlider(selectedMin, selectedMax);
		}

		this.rangeSlider = new RangeFacetView({
			hideButton: !useApplyButton,
			// allows range to expand to the user selected values
			min: Math.min(min, selectedMin),
			max: Math.max(max, selectedMax),
			selectedMin: selectedMin,
			selectedMax: selectedMax,
			onChange: useApplyButton ? null : this._setSliderGroupValues.bind(this),
			onApply: this._setSliderGroupValues.bind(this)
		});
		const $groupList = this.$el.find('ul.js-group-list');
		$groupList.replaceWith(this.rangeSlider.render().el);
	},

	_updateRangeSlider(selectedMin, selectedMax) {
		if (!this.model.get('selected')) {
			this.rangeSlider.resetValues();
		} else {
			this.rangeSlider.setValues(selectedMin, selectedMax);
		}
	},

	_isDefaultSliderValues(selectedMin, selectedMax) {
		const facetGroup = this.model.toJSON(),
			defaultMin = facetGroup.formatted.min,
			defaultMax = facetGroup.formatted.max;
		return selectedMin === defaultMin && selectedMax === defaultMax;
	},

	_setSliderGroupValues(selectedMin, selectedMax) {
		const selected = !this._isDefaultSliderValues(selectedMin, selectedMax),
			facetId = this.model.get('facetId'),
			groupName = this.model.get('groupName'),
			// direct slider manipulation will override any ranges that have been set by facet_banners
			isAdditive = false;
		// the special snowflake range facet triggers collection same as facet_banners
		this.model.collection.trigger('facets:items:rangeset', { facetId, groupName, selectedMin, selectedMax, selected, isAdditive });
	},

	/**
	 * ==================================================================================
	 * ************************ DICTIONARY TERMS [?] ************************************
	 * ==================================================================================
	 */

	_initDictionaryTerm() {
		this.facetDictionaryModel = this.model.get('dictionaryTerm');
		if (this.facetDictionaryModel) {
			this.categoryDictionaryModel = new FacetDictionaryModel({
				dictionaryId: this.facetDictionaryModel.dictionaryId,
				term: this.facetDictionaryModel.term
			});
		}
	},

	_fetchDictionaryTerm() {
		if (!this.categoryDictionaryModel.get('fetched')) {
			this.categoryDictionaryModel.fetch({
				success: this._buildDefinitionPopover.bind(this),
				error: this._showDefinitionError.bind(this)
			});
		}
	},

	_buildDefinitionPopover() {
		const $definitionModal = $(`.js-help-icon[data-term="${this.facetDictionaryModel.term}"]`);
		this.categoryDictionaryModel.set('fetched', true);
		$definitionModal.popover({
			content: this.categoryDictionaryModel.get('definition'),
			title: `${this.categoryDictionaryModel.get('term')}<h2 class="pull-right"> × </h2>`,
			placement: 'auto',
			container: 'body',
			trigger: 'focus',
			sanitize: false,
			html: true
		});
	},

	_showDefinitionError() {
		window.BCOM.notifications.render('There was an error retrieving the definition of this term.', 'warning');
	},

	_triggerHelpIconTracking(event) {
		const $el = $(event.target);
		Backbone.trigger('omniture:clicktracking', `${window.BCOM.device.deviceType}dictionaryhover_${$el.data('term')}`);
	},

	_filterFacetGroup(event) {
		const $el = $(event.target),
			filterTerm = String($el.val()).toLowerCase(),
			$matchingFacets = this._allFacets.filter(function() {
				return (
					$(this)
						.text()
						.toLowerCase()
						.indexOf(filterTerm) > -1
				);
			});

		this._allFacets.show();

		this._allFacets
			.not($matchingFacets)
			.not('.js-facet-filter-container')
			.hide();
	}
});
